import { createContext, useContext, useEffect, useState } from "react";

const DICT = {
  es: {
    "nav.vip": "Área VIP",
    "nav.comercial": "Comercial",
    "lang.switch": "EN",
    "hero.eyebrow": "Temporada 1 · 12 destinos.",
    "hero.l1": "Dos amigas.",
    "hero.l2a": "El mundo",
    "hero.l2b": " entero,",
    "hero.l3": "Una maleta.",
    "hero.sub":
      "Una sola maleta, doce destinos y la curiosidad suficiente para mirar de cerca a la gente, los sabores y las historias que hacen especial cada lugar. Anto y Bella recorren doce ciudades del planeta con curiosidad, risas y cero pose. La serie de viajes juvenil y familiar que se siente como una conversación con tu mejor amiga",
    "hero.ctaEp": "Ver los episodios",
    "hero.ctaDuo": "Conoce al dúo",
    "faq.eyebrow": "Preguntas del público",
    "faq.title": "Lo que todos preguntan",
    "faq.items": [
      { q: "¿Dónde puedo ver el programa?", a: "Sábados 20:00 por TV abierta en la zona Occidente de México, con retransmisión el domingo 11:00. También compartimos momentos en redes sociales." },
      { q: "¿Cuánto cuesta ser Believer?", a: "Nada. La comunidad Believer es 100% gratis: solo déjanos tu correo y te avisamos de cada estreno." },
      { q: "¿Qué incluye el Área VIP?", a: "Episodios sin cortes, detrás de cámaras, bloopers, sorteos de merch, chat exclusivo y tu nombre en los créditos digitales, desde $99 MXN al mes." },
      { q: "¿Es apto para toda la familia?", a: "Sí. Anto&Bella por el Mundo está pensado para adolescentes y familias: curioso, cálido y sin contenido inapropiado." },
      { q: "¿Habrá Temporada 2?", a: "¡Sí! Ya preparamos la nueva ruta con destinos como Oaxaca, El Cairo, Lisboa, Estambul, Buenos Aires y Vancouver. Suscríbete para enterarte del estreno." },
      { q: "Soy una marca, ¿cómo me anuncio?", a: "Visita las páginas Para Patrocinadores y Para Marcas: hay espacios de naming, co-branding y módulos por episodio, todos disponibles ahora mismo." },
    ],
    "notfound.code": "404",
    "notfound.title": "Te saliste de la ruta",
    "notfound.text": "Esta página se fue de viaje sin avisar. Volvamos al mapa y sigamos la aventura.",
    "notfound.cta": "Volver al inicio",
    "splash.tagline": "por el Mundo",
    "wa.label": "Escríbenos por WhatsApp",
    "wa.msg": "¡Hola! Escribo del sitio web, y quiero saber más del programa Anto&Bella por el Mundo.",
  },
  en: {
    "nav.vip": "VIP Area",
    "nav.comercial": "Business",
    "lang.switch": "ES",
    "hero.eyebrow": "Season 1 · 12 destinations",
    "hero.l1": "Two friends.",
    "hero.l2a": "The whole",
    "hero.l2b": " world.",
    "hero.l3": "One journey.",
    "hero.sub":
      "Anto and Bella travel through twelve cities around the planet with curiosity, laughter and zero posing. The family-friendly teen travel series that feels like a chat with your best friend.",
    "hero.ctaEp": "Watch the episodes",
    "hero.ctaDuo": "Meet the duo",
    "faq.eyebrow": "Audience questions",
    "faq.title": "What everyone asks",
    "faq.items": [
      { q: "Where can I watch the show?", a: "Saturdays at 8:00 PM on free-to-air TV in Western Mexico, with a rerun on Sunday at 11:00 AM. We also share moments on social media." },
      { q: "How much does it cost to be a Believer?", a: "Nothing. The Believer community is 100% free: just leave us your email and we'll let you know about every premiere." },
      { q: "What's included in the VIP Area?", a: "Uncut episodes, behind the scenes, bloopers, merch giveaways, an exclusive chat and your name in the digital credits, from $99 MXN a month." },
      { q: "Is it family-friendly?", a: "Yes. Anto&Bella Around the World is made for teens and families: curious, warm and free of inappropriate content." },
      { q: "Will there be a Season 2?", a: "Yes! We're already preparing the new route with destinations like Oaxaca, Cairo, Lisbon, Istanbul, Buenos Aires and Vancouver. Subscribe to hear about the premiere." },
      { q: "I'm a brand, how do I advertise?", a: "Visit the Sponsors and Brands pages: there are naming, co-branding and per-episode module slots, all available right now." },
    ],
    "notfound.code": "404",
    "notfound.title": "You went off the route",
    "notfound.text": "This page took off without telling anyone. Let's head back to the map and keep the adventure going.",
    "notfound.cta": "Back to home",
    "splash.tagline": "Around the World",
    "wa.label": "Message us on WhatsApp",
    "wa.msg": "Hi! I'd like to know more about Anto&Bella Around the World.",
  },
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("ab_lang") || "es");

  useEffect(() => {
    localStorage.setItem("ab_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key) => {
    const val = DICT[lang][key];
    return val !== undefined ? val : key;
  };

  const toggle = () => setLang((l) => (l === "es" ? "en" : "es"));

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
